export const AT_LEAST_8_CHARACTERS = /.{8,}$/;

export const AT_LEAST_1_NUMBER = /\d/;

export const AT_LEAST_1_CAPITAL_LETTER = /[A-Z]/;

export const AT_LEAST_1_SPECIAL_CHARACTER =
    /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
